export type Environment = {
  url: string;
  masterLocationUrl: string;
  mapServiceUrl: string;
  amsURL?: string;
  platformUrl?: string;
  tolgee?: {
    apiKey?: string;
    apiURL?: string;
    cdnUrl?: string;
  }
};
